export { default } from "/Users/anirudh/not_work/sharepath-remix/app/routes/index.tsx";